import React from 'react';
import PropTypes from 'prop-types';

const TrackIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '16px';
  const h = (height) ? height.toString().concat('px') : '18px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 16 18"
      width={w}
      height={h}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
                // eslint-disable-next-line max-len
        d="M3.94119 3.44119C5.02404 2.35834 6.4927 1.75 8.02409 1.75C9.55547 1.75 11.0241 2.35834 12.107 3.44119C13.1898 4.52404 13.7982 5.9927 13.7982 7.52409C13.7982 9.75978 12.3429 11.9328 10.7417 13.623C9.95641 14.4519 9.16861 15.1305 8.57628 15.6022C8.36291 15.7721 8.17568 15.9145 8.02409 16.0268C7.87249 15.9145 7.68527 15.7721 7.47189 15.6022C6.87957 15.1305 6.09176 14.4519 5.30651 13.623C3.70533 11.9328 2.25 9.75978 2.25 7.52409C2.25 5.9927 2.85834 4.52404 3.94119 3.44119ZM7.60766 17.5715C7.60787 17.5717 7.60806 17.5718 8.02409 16.9478L7.60806 17.5718C7.85999 17.7398 8.18819 17.7398 8.44011 17.5718L8.02409 16.9478C8.44011 17.5718 8.4403 17.5717 8.44052 17.5715L8.44107 17.5712L8.44262 17.5701L8.4475 17.5669L8.4642 17.5556C8.47838 17.5459 8.49857 17.5321 8.52438 17.5142C8.576 17.4785 8.65012 17.4264 8.74354 17.359C8.93029 17.2241 9.19461 17.0273 9.51067 16.7756C10.1416 16.2732 10.9848 15.5473 11.8306 14.6546C13.4915 12.9015 15.2982 10.3627 15.2982 7.52409C15.2982 5.59488 14.5318 3.74469 13.1676 2.38053C11.8035 1.01637 9.9533 0.25 8.02409 0.25C6.09488 0.25 4.24469 1.01637 2.88053 2.38053C1.51637 3.74469 0.75 5.59488 0.75 7.52409C0.75 10.3627 2.55672 12.9015 4.21758 14.6546C5.06335 15.5473 5.90657 16.2732 6.5375 16.7756C6.85357 17.0273 7.11788 17.2241 7.30464 17.359C7.39805 17.4264 7.47218 17.4785 7.52379 17.5142C7.5496 17.5321 7.5698 17.5459 7.58397 17.5556L7.60068 17.5669L7.60555 17.5701L7.60711 17.5712L7.60766 17.5715ZM6.59863 7.52406C6.59863 6.73722 7.23649 6.09937 8.02333 6.09937C8.81017 6.09937 9.44802 6.73722 9.44802 7.52406C9.44802 8.3109 8.81017 8.94876 8.02333 8.94876C7.23649 8.94876 6.59863 8.3109 6.59863 7.52406ZM8.02333 4.59937C6.40806 4.59937 5.09863 5.9088 5.09863 7.52406C5.09863 9.13933 6.40806 10.4488 8.02333 10.4488C9.63859 10.4488 10.948 9.13933 10.948 7.52406C10.948 5.9088 9.63859 4.59937 8.02333 4.59937Z"
        fill={(fill) || '#FF5F14'}
      />
    </svg>
  );
};

TrackIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default TrackIcon;
